import {
    processGetManyFilter,
    processGetManyByReferenceFilter,
    processFilters, addSortToUrl, readJsonOrRefuse, refuseOnHttpError} from "./provider/defaults";
import {
    CreateParams, CreateResult,
    DataProvider,
    DeleteManyParams,
    DeleteParams,
    GetListParams, GetListResult,
    GetManyParams,
    GetManyReferenceParams, GetManyReferenceResult, GetManyResult,
    GetOneParams, GetOneResult,
    UpdateManyParams, UpdateManyResult,
    UpdateParams, UpdateResult
} from "react-admin";
import {string} from "prop-types";
import { read_cookie, delete_cookie } from 'sfcookies';
import { hostUrl, UseUrlManagerCleanUrl, apiUrl } from "../components/utils/url-manager";
import { addUrlToUri, removeUrlFromUri, restoreEntityString, cleanEntityString } from "./provider/defaults";
import { CompaniesHouseFilingHistory } from "../types/entities";


function cleanParams(params: any[]): CompaniesHouseFilingHistory {
    let pdf = undefined;
    if (typeof params['pdf'] !== "undefined") {
         pdf = {
            'src': params['pdf'], 'title': ( params['pdf'] ? params['pdf'].replace('companies-houses/') : '' )
        };
    }

    let returnObject: CompaniesHouseFilingHistory = {
        id: params['id'],
        date: params['date'],
        description: params['description'],
        companiesHouse: cleanEntityString(params['companiesHouse'], '/hq_api/companies_houses/'),
        viewPdr: params['viewPdf'],
        pdf: pdf
    }

    return returnObject;
}

const adminCompaniesHouseFilingHistoryDataProvider: DataProvider = {

    getList:  async  (resource: string, params: GetListParams): Promise<GetListResult> => {
        let token: string = read_cookie('auth');
        let url: string = apiUrl + resource;
        if (params.pagination) {
            url += '?page=' + params.pagination.page + '&itemsPerPage=' + params.pagination.perPage;
        }
        url = processFilters(url, params);
        url = addSortToUrl(url, params);
        url = UseUrlManagerCleanUrl({ url: url });
        const request: Request = new Request(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response) => {
                return readJsonOrRefuse(response);
            })
            .then( (data: any) => {
                let responseData: { data: CompaniesHouseFilingHistory[], total: number } = {
                    data: [],
                    total: 0
                };
                if (Array.isArray(data['hydra:member'])) {
                    let filings: any[] = data['hydra:member'];
                    let totalItems: number = data['hydra:totalItems'];

                    for(let i: number = 0; i < filings.length; i++) {
                        let filing: any[] = filings[i];
                        responseData.data.push(cleanParams(filing))
                    }
                    responseData.total = totalItems;
                }
                return responseData;
            })
            .catch( (error: Error) => {
                console.log(error);
                return Promise.reject(error)
            });
        //return Promise.reject();
    },
    // get a single record by id
    getOne: async (resource: string, params: GetOneParams) : Promise<GetOneResult> => {
        let token: string = read_cookie('auth');
        let url: string = apiUrl + resource + params.id;
        url = UseUrlManagerCleanUrl({ url: url });
        const request: Request = new Request(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response) => {
                return readJsonOrRefuse(response);
            })
            .then( (data: any) => {
                console.log(data);
                let responseData: { data: CompaniesHouseFilingHistory|null } = {
                    data: null
                };
                if (data['id']) {
                    responseData = {
                        data: cleanParams(data)
                    };
                }
                return responseData;
            })
            .catch( (error: Error) => {
                console.log(error);
                return Promise.reject(error);
            });
    },
    // get a list of records based on an array of ids
    getMany: async (resource: string, params: GetManyParams): Promise<GetManyResult> => {
        let token: string = read_cookie('auth');
        let url: string = apiUrl + resource;
        url = processGetManyFilter(url, params);
        url = addSortToUrl(url, params);
        url = UseUrlManagerCleanUrl({ url: url });
        const request: Request = new Request(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response) => {
                return readJsonOrRefuse(response);
            })
            .then( (data: any) => {

                let responseData: { data: CompaniesHouseFilingHistory[], total: number } = {
                    data: [],
                    total: 0
                };

                if (Array.isArray(data['hydra:member'])) {
                    let companies: any[] = data['hydra:member'];
                    let totalItems: number = data['hydra:totalItems'];

                    for(let i: number = 0; i < companies.length; i++) {
                        let company: any[] = companies[i];
                        responseData.data.push(cleanParams(company));
                    }
                    responseData.total = totalItems;
                }
                return responseData;
            })
            .catch( (error: Error) => {
                console.log(error);
                return Promise.reject(error);
            });
    },
    // get the records referenced to another record, e.g. comments for a post
    getManyReference: async (resource: string, params: GetManyReferenceParams) : Promise<GetManyReferenceResult> => {
        let token: string = read_cookie('auth');
        let url: string = apiUrl + resource;
        if (params.pagination) {
            url += '?page=' + params.pagination.page + '&itemsPerPage=' + params.pagination.perPage;
        }
        url = processGetManyByReferenceFilter(url, params);
        url = addSortToUrl(url, params);
        url = UseUrlManagerCleanUrl({ url: url });
        const request : Request = new Request(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response) => {
                return readJsonOrRefuse(response);
            })
            .then(data => {
                let responseData: { data: CompaniesHouseFilingHistory[], total: number } = {
                    data: [],
                    total: 0
                };

                if (Array.isArray(data['hydra:member'])) {
                    let filings: any[] = data['hydra:member'];
                    let totalItems: number = data['hydra:totalItems'];

                    for(let i: number = 0; i < filings.length; i++) {
                        let filing: any[] = filings[i];
                        responseData.data.push(cleanParams(filing));
                    }
                    responseData.total = totalItems;
                }
                return responseData;
            })
            .catch( (error: Error) => {
                console.log(error);
                return Promise.reject(error)
            });
    },
    // create a record
    create: async (resource: string, params: CreateParams) : Promise<CreateResult> => {

        let token: string = read_cookie('auth');
        // set the date as required
        params.data.companiesHouse = '/hq_api/companies_houses/' + params.data.companiesHouse;

        try {
            if (params.data.pdf !== undefined) {
                params.data.file_name = params.data.pdf.title;
                params.data.pdf = await convertFileToBase64(params.data.pdf) ?? '';
            }
        } catch (error) {
            console.log(error);
            params.data.file_name = '';
            params.data.pdf = '';
        }
        let url: string = apiUrl + resource;
        url = UseUrlManagerCleanUrl({ url: url });
        const request: Request = new Request(url, {
            method: 'POST',
            body: JSON.stringify(params['data']),
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response) => {
                return readJsonOrRefuse(response);
            })
            .then(data => {
                let responseData: { data: CompaniesHouseFilingHistory|null } = {
                    data: null
                };
                if (data['id']) {
                    responseData.data = cleanParams(data)
                }
                return responseData;
            })
            .catch( (error: Error) => {
                console.log(error);
                return Promise.reject(error);
            });

    },
    // update a record based on a patch
    update: async (resource: string, params: UpdateParams) : Promise<UpdateResult> => {
        let token: string = read_cookie('auth');

        delete params.data.viewPdf;
        params.data.companiesHouse = '/hq_api/companies_houses/' + params.data.companiesHouse;

        if (params.data.pdf !== undefined && params.data.pdf !== string) {
            params.data.file_name = params.data.pdf.title;
            params.data.pdf = await convertFileToBase64(params.data.pdf) ?? '';
        }
        let url: string = apiUrl + resource + '/' + params.data.id;
        url = UseUrlManagerCleanUrl({ url: url });
        const request: Request = new Request(url, {
            method: 'PATCH',
            body: JSON.stringify(params['data']),
            headers: new Headers({
                'Content-Type' : 'application/merge-patch+json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response) => {
                return readJsonOrRefuse(response);
            })
            .then( (data: any) => {
                console.log(data);
                let responseData: { data: CompaniesHouseFilingHistory|null } = {
                    data: null
                };
                if (data['id']) {
                    responseData.data = cleanParams(data)
                }
                return responseData;
            })
            .catch( (error: Error) => {
                console.log(error);
                return Promise.reject(error);
            });
    },
    // update a list of records based on an array of ids and a common patch
    updateMany: async (resource: string, params: UpdateManyParams) : Promise<UpdateManyResult> => {
        return Promise.reject();
    },
    // delete a record by id
    delete: async (resource: string, params: DeleteParams) : Promise<any> => {
        let token: string = read_cookie('auth');
        let url: string = apiUrl + resource + '/' + params.id;
        url = UseUrlManagerCleanUrl({ url: url });
        const request: Request = new Request(url, {
            method: 'DELETE',
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response) => {
                return refuseOnHttpError(response)
                    .then((): { data: any } => ({ data: params }));
            })
            .catch( (error: Error) => {
                console.log(error);
                return Promise.reject(error);
            });
    },
    // delete a list of records based on an array of ids
    deleteMany: async (resource: string, params: DeleteManyParams) => {
        return Promise.reject();
    },
    getProfileData: (params) => {
        return Promise.resolve();
    }
}

const convertFileToBase64 = file => {
    if (typeof file.src === "undefined" || file === "" || file.src === "") {
        return new Promise((resolve, reject) => {
            resolve('');
        });
    } else if (file.src.startsWith('/companies-house/')) {
        return new Promise((resolve, reject) => {
            resolve(file.src);
        });
    } else {
        return new Promise((resolve, reject) => {
            const reader: FileReader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(file.rawFile);
        });
    }

}

export default adminCompaniesHouseFilingHistoryDataProvider;